export const UTCTimezone = 'Etc/Utc';
export const SUPPORTED_DATE_TIME_UTC_STRING = '2021-08-26T06:20:36Z';
